import * as Yup from "yup";

export const getProductQuery = `query Products ($filter: ProductAttributeFilterInput!, $sort: ProductAttributeSortInput!, $pageSize: Int!, $currentPage: Int!){
  products(
      filter: $filter,
      sort: $sort,
      pageSize: $pageSize,
      currentPage: $currentPage
  ) {
  currentcategory{
      name
      description
      dynamic_content
      imageUrl
      meta_keywords
      meta_description
      meta_title
      schema
      breadcrumbs{
        category_id
        category_name
        category_level
        category_url_key
        category_url_path
    }
  }
  appliedFilters{
    label
    value
    attribute_code
  }
  aggregations(filter: { category: {includeDirectChildrenOnly: true}}) {
      attribute_code
      count
      label
      options {
          label
          value
          count
          swatch_data {
              type
              value
          }
      }
  }
  subcategories{
      id
      name
      imageUrl
  }
  total_count
  items {
      id
      name
      sku
      url_key
      price_range {
      minimum_price {
          regular_price {
          value
          currency
          }
          final_price {
          value
          currency
          }
          discount {
          amount_off
          percent_off
          }
      }
      maximum_price {
          regular_price {
          value
          currency
          }
          final_price {
          value
          currency
          }
          discount {
          amount_off
          percent_off
          }
      }
      }
      extraVariables{
        skd_stock
        dora_stock
        hoskote_stock
        west_zone_stock
          is_enabled
          is_new
          image_url
          ambience_image_url
          product_url
          tile_size
          sq_ft_price
      }
  }
  total_count
  sort_fields{
      default
      options {
      value
      label
      }
  }
  }
}`;

export const steps = [
  {
    id: 1,
    question: "Are you a...?",
    options: [
      { label: "Homeowner", value: 1, action: false },
      { label: "Builder", value: 2, action: false },
      { label: "Architect", value: 3, action: false },
      { label: "Contractor", value: 4, action: false },
    ],
  },
  {
    id: 2,
    question: "For which area are you looking for tiles?",
    options: [
      { label: "Bathroom", value: 100, url: "bathroom-tiles", action: false },
      { label: "Kitchen", value: 101, url: "kitchen-tiles", action: false },
      {
        label: "Living Room",
        value: 107,
        url: "living-room-tiles",
        action: false,
      },
      { label: "Bedroom", value: 104, url: "bedroom-tiles", action: false },
      { label: "Elevation", value: 103, url: "elevation-tiles", action: false },
      { label: "Parking", value: 102, url: "parking-tiles", action: false },
      { label: "Balcony", value: 108, url: "balcony-tiles", action: false },
    ],
  },
  {
    id: 3,
    question: "Floor or Wall Tiles?",
    options: [
      {
        label: "Floor",
        value: "tile_category=222",
        action: false,
      },
      {
        label: "Wall",
        value: "tile_category=223",
        action: false,
      },
      { label: "Both", value: "", action: false },
    ],
  },
  { id: 4, question: "What sizes do you prefer?", options: [] },
];

export const sizeOptionsList = {
  Bathroom: [
    { label: "300x450mm", value: 267, action: false },
    { label: "300x300mm", value: 268, action: false },
  ],
  Kitchen: [
    { label: "300x450mm", value: 267, action: false },
    { label: "300x300mm", value: 268, action: false },
    { label: "600x600mm", value: 264, action: false },
  ],
  "Living Room": [
    { label: "1200x1800mm", value: 497, action: false },
    { label: "800x800mm", value: 263, action: false },
    { label: "600x1200mm", value: 262, action: false },
    { label: "600x600mm", value: 264, action: false },
    { label: "800x2400mm", value: 455, action: false },
  ],
  Bedroom: [
    { label: "1200x1800mm", value: 497, action: false },
    { label: "800x800mm", value: 263, action: false },
    { label: "600x1200mm", value: 262, action: false },
    { label: "600x600mm", value: 264, action: false },
    { label: "800x2400mm", value: 455, action: false },
  ],
  Elevation: [
    { label: "250x375mm", value: 270, action: false },
    { label: "300x450mm", value: 267, action: false },
    { label: "300x600mm", value: 266, action: false },
  ],
  Parking: [
    { label: "400x400mm", value: 336, action: false },
    { label: "300x300mm", value: 268, action: false },
  ],
};

export const getInTouchValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid phone number")
    .required("Phone number is required"),
  pincode: Yup.string()
    .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
    .required("Pincode is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
});
